export const LANG_AKI_ES = {
  footer: {
    company: '© {{ year }} Aaron King International parte de Reverse SpA',
    headquarter: 'VAT B72409337',
    informations: [
      'VAT Number: 09714690964',
      'PEC: reversespa@pec.it',
      'Commercial registry: MI - 2109818',
      'Paid up share capital: 50.000€',
      'REA Number: MI - 2109818',
    ],
    companyBaseUrl: 'https://www.reverse.hr/es/',
    menu: {
      contact: {
        label: 'Contáctenos',
        slug: 'https://reverse.hr/es/contactenos/',
      },
      legal: {
        label: 'Cookies',
        slug: 'https://reversegroup.hr/es/legal/',
      },
      cookies: {
        label: 'Legal&privacy',
        url: 'https://www.iubenda.com/privacy-policy/41212079/cookie-policy',
      },
    },
  },
};
